import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/home/Manifesto";
import Method from "@/components/Method";
import LiveExperience from "@/components/home/LiveExperience";
import Pillars from "@/components/home/Pillars";
import Comparison from "@/components/home/Comparison";
import PerformanceBand from "@/components/home/PerformanceBand";
import CorporateBand from "@/components/home/CorporateBand";
import Coach from "@/components/home/Coach";
import Proof from "@/components/home/Proof";
import Audience from "@/components/home/Audience";
import Online from "@/components/home/Online";
import PricingTable from "@/components/PricingTable";
import FinalCTA from "@/components/FinalCTA";
import { usePageMeta } from "@/components/blocks";

export default function Home() {
  usePageMeta(
    "StrengthLeap | Private 1:1 Live Performance Coaching",
    "Private 1:1 performance coaching in real time, anywhere in the world. Live video sessions with real-time form correction — eliminate pain, build strength, prepare for your biggest goals."
  );

  return (
    <main>
      <Hero />
      <Marquee />
      <Manifesto />
      <Method />
      <LiveExperience />
      <Pillars />
      <Comparison />
      <PerformanceBand />
      <CorporateBand />
      <Coach />
      <Proof />
      <Audience />
      <Online />
      <PricingTable />
      <FinalCTA />
    </main>
  );
}
